import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import { aboutContent } from '@/mocks/filters';
import { mediaList } from '@/mocks/media';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

const VALUES = [
  { icon: 'ri-compass-3-line', title: '内容聚合', desc: '聚合电影、电视剧、综艺多类型影视资讯，让好内容不再被埋没。' },
  { icon: 'ri-search-eye-line', title: '便捷检索', desc: '支持关键词搜索与多维筛选，几秒钟找到你想看的那一部。' },
  { icon: 'ri-play-circle-line', title: '观看入口', desc: '为每部内容提供清晰的高清观看入口，演示环境亦可直观体验。' },
];

export default function AboutPage() {
  useDocumentTitle(
    '关于我们 - 蘑菇视频',
    '了解蘑菇视频的定位、内容理念与服务范围，以及版权与免责声明、联系方式等信息。',
  );

  return (
    <div className="w-full max-w-content mx-auto px-4 md:px-8 py-6">
      <Breadcrumb items={[{ label: '关于我们' }]} />

      <section className="mt-4 rounded-lg bg-background-100 border border-background-200 p-6 md:p-12">
        <span className="inline-block px-3 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-medium mb-4">
          关于我们
        </span>
        <h1 className="text-2xl md:text-4xl font-black text-foreground-950 mb-4">关于蘑菇视频</h1>
        <p className="text-base md:text-lg leading-relaxed text-foreground-600 max-w-3xl">{aboutContent.intro}</p>
        <p className="mt-4 text-sm md:text-base font-medium text-primary-600">{aboutContent.mission}</p>
      </section>

      <section className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
        {VALUES.map((value) => (
          <div key={value.title} className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center mb-4">
              <i className={`${value.icon} text-2xl`}></i>
            </span>
            <h2 className="text-base font-bold text-foreground-950 mb-2">{value.title}</h2>
            <p className="text-sm leading-relaxed text-foreground-500">{value.desc}</p>
          </div>
        ))}
      </section>

      <section className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        <div className="lg:col-span-2 flex flex-col gap-4 md:gap-6">
          <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <h2 className="text-base font-bold text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-copyright-line text-primary-500"></i>
              版权声明
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600">
              本站所有文字、图片与影音资料仅用于产品演示与学习交流，相关影视内容的版权归原权利方所有。本站不提供任何影视资源的存储与下载服务，如权利方认为内容涉及侵权，请通过下方邮箱与我们联系，我们将第一时间处理。
            </p>
          </div>

          <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <h2 className="text-base font-bold text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-shield-check-line text-accent-500"></i>
              免责声明
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600">
              本站展示的影视评分、热度与资讯信息均为演示数据，不构成任何实际参考。站内"视频播放"仅为前端演示界面，暂未接入真实播放接口，不产生真实播放与下载行为。请用户知悉并理性使用。
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-4 md:gap-6">
          <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <h2 className="text-base font-bold text-foreground-950 mb-4">联系我们</h2>
            <a
              href={`mailto:${aboutContent.email}`}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line text-lg"></i>
              {aboutContent.email}
            </a>
            <p className="mt-4 text-xs text-foreground-500">如有合作、反馈或侵权投诉，欢迎随时邮件联系。</p>
          </div>

          <div className="rounded-lg bg-secondary-950 p-5 md:p-6 text-background-100">
            <p className="font-heading font-black text-3xl text-primary-400 mb-1">{mediaList.length}</p>
            <p className="text-sm text-background-200/80 mb-4">精选影视内容持续更新中</p>
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-1 text-sm text-primary-300 hover:text-primary-200 transition-colors cursor-pointer"
            >
              去发现更多
              <i className="ri-arrow-right-s-line text-lg"></i>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}